import type { DateTime } from "luxon";
import { createContext, type SetStateAction } from "react";

export const WeekIndexContext = createContext({
	weekIndex: 0,
	setWeekIndex: (_: number): void => {},
	/** With the schedule cache on, the shown Sunday week's first day, once a page has named one (`useShownWeek`). */
	shownWeekStart: undefined as DateTime | undefined,
	setShownWeekStart: (_: SetStateAction<DateTime | undefined>): void => {},
	viewStartDay: 0,
	setViewStartDay: (_: number): void => {},
});
